import React from 'react';
import PageHero from '../components/PageHero';
import BackButton from '../components/BackButton';
import About from '../components/About';
import AboutAislinn from '../components/AboutAislinn';
import AboutJason from '../components/AboutJason';
import BoardOfDirectors from '../components/BoardOfDirectors';

function MeetUsPage() {
  return (
    <>
      <PageHero
        label="Our Team"
        title="Meet Us"
        subtitle="The people behind the architecture."
      />
      <BackButton />
      <About />
      <AboutAislinn />
      <AboutJason />
      <BoardOfDirectors />
      <div style={{
        textAlign: 'center',
        padding: '4rem 2rem',
        maxWidth: '800px',
        margin: '0 auto'
      }}>
        <p style={{
          fontSize: '1.4rem',
          color: '#c0c0c0',
          fontStyle: 'italic',
          lineHeight: '1.8'
        }}>
          There is no I in team, and a great vision needs great people<a
            href="/immortal-monster/#ch1"
            style={{
              color: '#c0c0c0',
              textDecoration: 'none',
              fontSize: '1.4rem'
            }}
          >.</a>
        </p>
      </div>
    </>
  );
}

export default MeetUsPage;
